import LinkIcon from '@mui/icons-material/Link';
import { Button, Stack, Typography } from '@mui/material';
import settings from '/@/core/settings';
import { _ } from '/@/locale';

import { loadBase64Image } from '/@/utils/pdf';

const ReportFooter = () => {
    const base64Banner = loadBase64Image('src/views/fields/field-monitoring/report/assets/Banner.png');

    return (
        <Stack
            direction='column'
            justifyContent='space-between'
            alignItems='center'
            py={8}
            px={18}
            spacing={5}
            sx={{
                backgroundImage: `url(${base64Banner})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}
        >
            <Stack direction='column' spacing={2} justifyContent='space-between' alignItems='center'>
                <Typography variant='h4' sx={{ color: 'white !important' }}>
                    {settings.app.name}
                </Typography>
                <Typography variant='subtitle2' sx={{ color: 'white !important' }}>
                    {_(
                        'Donde encontrarás en un mismo lugar, todas las soluciones integrales, recomendaciones y experiencias, además de herramientas técnicas. Registratete y comenzá a seguir tus lotes con recomendaciones personalizadas. '
                    )}
                </Typography>
            </Stack>
            <Button variant='contained' color='secondary' sx={{ fontStyle: 'italic' }} startIcon={<LinkIcon />}>
                {settings.app.url.toUpperCase()}
            </Button>
        </Stack>
    );
};

export default ReportFooter;
